/**
 * @desc 系统主题切换
 * @param type - 样式标记
 */

export function changeColor(type: any) {
  localStorage.setItem('colorType', type);
  const domStyle = document.getElementsByTagName('body')[0].style;
  domStyle.setProperty('--borderTransition', '0'); // 暂时去除动画时间
  domStyle.setProperty('--buttonTransition', '0'); // 暂时去除动画时间
  domStyle.setProperty('--transitionTime', '0'); // 暂时去除动画时间 公共
  switch (type) {
    case '0':
      domStyle.setProperty('--mainBackground', '#f1f6fd'); // 主要背景色
      domStyle.setProperty('--secondBackground', '#ffffff'); // 第二背景色
      domStyle.setProperty('--secondBackgroundChange', '#ffffff'); // 第二背景色 不一样的颜色变化
      domStyle.setProperty('--thirdBackgroundChange', '#f9f9f9'); // 第三背景色

      domStyle.setProperty('--mainText', '#666666'); // 主要文本色
      domStyle.setProperty('--blackText', '#000c17'); // 更黑文本色
      domStyle.setProperty('--mainTextLight', '#ffffff'); // 主要亮色文本色
      domStyle.setProperty('--mainHeaderBackgroundColor', '#4c64fe'); // 外框头部颜色
      domStyle.setProperty('--mainLine', '#eeeeee'); // 边框、分割线颜色

      domStyle.setProperty('--whiteToGrey', '#ffffff'); // 白色变换灰色 处理无边框输入框深色模式下显示

      domStyle.setProperty('--elBorder', '#dcdfe6'); // el-ui 输入框边框颜色

      domStyle.setProperty('--whiteToMainColor', '#c6ceff'); // 白色切换主色 头部标题竖线

      domStyle.setProperty('--scrollbar', '#cecece'); // 滚动条背景色

      domStyle.setProperty('--mainBoxShadow', 'rgba(76, 100, 254, 0.15)'); // 主要阴影颜色

      domStyle.setProperty('--boxShadow-1', 'rgba(230, 237, 253, 1)'); // 菜单滑块上、下阴影颜色
      domStyle.setProperty('--boxShadow-2', 'rgba(76, 100, 254, 0.08)'); // 菜单滑块左侧阴影颜色

      domStyle.setProperty('--menuShadowHeight', '40px'); // 菜单滑块遮盖位置调整
      domStyle.setProperty('--menuShadowMarginTop', '5px'); // 菜单滑块遮盖位置调整
      domStyle.setProperty('--menuShadowHeight-2', '60px'); // 菜单滑块遮盖位置调整
      domStyle.setProperty('--menuShadowMarginTop-2', '-5px'); // 菜单滑块遮盖位置调整

      domStyle.setProperty('--elTableHeaderBackgroundColor', '#f6f6f6'); // el-ui 表格头颜色
      domStyle.setProperty('--elBackgroundColorBase', '#f5f7fa'); // el-ui 基础背景 hover颜色
      domStyle.setProperty('--elPageButtonBackgroundColor', '#f4f4f5'); // el-ui 分页按钮颜色
      domStyle.setProperty('--elTableStripeBackgroundColor', '#fafafa'); // el-ui 斑马条纹颜色

      domStyle.setProperty('--blackWhite', 'rgba(0, 0, 0,.1)'); // el-ui 阴影颜色

      domStyle.setProperty('--treeShadow', '#e0e0e0'); // 树控件阴影

      break;
    case '1':
      domStyle.setProperty('--mainBackground', '#252525');
      domStyle.setProperty('--secondBackground', '#202020');
      domStyle.setProperty('--secondBackgroundChange', '#191919'); // 第二背景色 不一样的颜色变化
      domStyle.setProperty('--thirdBackgroundChange', '#252525'); // 第三背景色

      domStyle.setProperty('--mainText', '#bbbbbb');
      domStyle.setProperty('--blackText', '#ccc'); // 更黑文本色
      domStyle.setProperty('--mainTextLight', '#bbbbbb');
      domStyle.setProperty('--mainHeaderBackgroundColor', '#2b2b2b');
      domStyle.setProperty('--mainLine', '#333333');

      domStyle.setProperty('--whiteToGrey', '#333333'); // 白色变换灰色 处理无边框输入框深色模式下显示

      domStyle.setProperty('--elBorder', '#333333'); // el-ui 输入框边框颜色

      domStyle.setProperty('--whiteToMainColor', '#4c64fe'); // 白色切换主色

      domStyle.setProperty('--scrollbar', '#333');

      domStyle.setProperty('--mainBoxShadow', 'rgba(76, 100, 254, 0)');

      domStyle.setProperty('--boxShadow-1', 'rgba(230, 237, 253, 0)');
      domStyle.setProperty('--boxShadow-2', 'rgba(76, 100, 254, 0)');

      domStyle.setProperty('--menuShadowHeight', '50px');
      domStyle.setProperty('--menuShadowMarginTop', '0');
      domStyle.setProperty('--menuShadowHeight-2', '70px');
      domStyle.setProperty('--menuShadowMarginTop-2', '-10px');

      domStyle.setProperty('--elTableHeaderBackgroundColor', '#2b2b2b');
      domStyle.setProperty('--elBackgroundColorBase', '#2b2b2b');
      domStyle.setProperty('--elPageButtonBackgroundColor', '#2b2b2b');
      domStyle.setProperty('--elTableStripeBackgroundColor', '#252525');
      domStyle.setProperty('--blackWhite', 'rgba(255, 255, 255,.1)');

      domStyle.setProperty('--treeShadow', '#00000000'); // 树控件阴影
      break;
  }
  setTimeout(() => {
    domStyle.setProperty('--borderTransition', '0.2s'); // 还原去除的动画时间
    domStyle.setProperty('--buttonTransition', '0.1s'); // 暂时去除动画时间
    domStyle.setProperty('--transitionTime', '0.3s'); // 暂时去除动画时间 公共
  }, 300);
}
